import Collaborator from './collaborator.js';
export default Collaborator;
